import { z } from 'zod';
import {
  ReferralStoredDocumentsSchema,
  requiresReferralDocumentOfType,
} from '../ReferralDocumentsSchema';
import { ReferralDocumentType } from '../../enums';

// The documents of an L&G referral: the shared typed array (PPL-3549), plus
// what L&G requires of it — a case manager cannot refer without the clinical
// report the nurse reads and the member's signed consent.
export const ReferralLandgDocumentsSchema =
  ReferralStoredDocumentsSchema.refine(
    ...requiresReferralDocumentOfType(
      ReferralDocumentType.clinicalReport,
      'Latest clinical report is required',
    ),
  ).refine(
    ...requiresReferralDocumentOfType(
      ReferralDocumentType.patientReferralConsent,
      'Consent form is required',
    ),
  );

export type ReferralLandgDocuments = z.infer<
  typeof ReferralLandgDocumentsSchema
>;
